<!--
 * @Description: 资金管理T+0结算
 * @Author: xu wei
 * @Date: 2020-02-27 15:57:01
 * @LastEditTime: 2020-07-18 11:26:48
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>资金管理</el-breadcrumb-item>
        <el-breadcrumb-item>T+0结算列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" type="number" v-model="tenantId" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>余额：</span>
          <span class="txtbox">
            <el-input style="width:100px;" type="number" size="small" v-model="ontherecharge" @input="ontherecharge=intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
            <el-input style="width:100px;" type="number" size="small" v-model="undertherecharge" @input="undertherecharge=intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist();staicInfo();}">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <div style=" margin-top: 20px;background: #fff;padding: 5px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-button size="small" type="warning" :disabled="selcetlist.length===0" @click="submitMoney">提现结算</el-button>
        <span class='tit' style="float: right;font-size: 14px;padding: 8px;">账户余额总额：<i style="color:red;">{{tatolMoney}}</i>元</span>
      </div>
      <el-table ref="moduleTable" size="mini" @selection-change="selchange" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="merchantId" label="商户ID" width="80">
        </el-table-column>
        <el-table-column label="商户名/账号">
          <template slot-scope="scope">
            <p>{{scope.row.nickName}}</p>
            <p style="color:#666;">{{scope.row.account}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="收款人">
        </el-table-column>
        <el-table-column prop="bankName" label="收款银行">
        </el-table-column>
        <el-table-column prop="bankBranch" label="开户地区">
        </el-table-column>
        <el-table-column prop="bankNumber" label="银行卡号">
        </el-table-column>
        <el-table-column prop="overMoney" label="账户余额">
          <template slot-scope="scope">
            <span>{{scope.row.overMoney.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算金额">
          <template slot-scope="scope">
            <!-- <el-input class="greenInput" size="mini" type="number" v-model="scope.row.canSettlement" placeholder="请输入内容"></el-input> -->
            <el-input class="greenInput" size="mini" type="number" @input="()=>{scope.row.canSettlement=((parseFloat(scope.row.canSettlement)+parseFloat(scope.row.charge))>scope.row.overMoney?(scope.row.overMoney-scope.row.charge).toFixed(2):scope.row.canSettlement)}" v-model="scope.row.canSettlement" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="手续费">
          <template slot-scope="scope">
            <el-input class="redInput" size="mini" type="number" @input="()=>{scope.row.charge=parseFloat(scope.row.charge);scope.row.canSettlement=(scope.row.overMoney-scope.row.charge<0?0:(scope.row.overMoney-scope.row.charge).toFixed(2))}" v-model="scope.row.charge" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tenantId: '', // 商户ID
      accountnumber: '', // 商户账号
      ontherecharge: '', // 充值金额上
      undertherecharge: '', // 充值金额下
      tatolMoney: 0, // 账户余额总额
      selcetlist: [], // 列表的多选
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: []
    };
  },
  methods: {
    // T+0列表
    getlist() {
      this.$api.money
        .tzerolist({
          MerchantId: this.tenantId === '' ? 0 : parseFloat(this.tenantId),
          Account: this.accountnumber,
          MinAmount: this.ontherecharge,
          MaxAmount: this.undertherecharge,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取T+0统计信息
    staicInfo() {
      this.$api.money
        .tzeroStaic()
        .then((data) => {
          if (data.status === 200) {
            this.tatolMoney = data.data.toFixed(2);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 多选的选项变化时
    selchange(data) {
      this.selcetlist = data.map((item) => {
        return item.id;
      });
    },
    // 提现结算
    submitMoney() {
      let arr = [];
      this.selcetlist.forEach((item) => {
        let arr1 = this.tableData.filter((li) => li.id === item)[0];
        if (arr1) {
          arr.push({
            bankId: arr1.id,
            merchantId: arr1.merchantId,
            amount: parseFloat(arr1.canSettlement),
            charge: parseFloat(arr1.charge)
          });
        }
      });
      this.$api.money
        .tzeroMoney(arr)
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('提现结算成功！');
            this.getlist();
            this.staicInfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
      this.staicInfo();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
      this.staicInfo();
    }
  },
  created() {
    this.getlist();
    this.staicInfo();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tableinfo {
  background: #fff;
  padding: 8px 20px;
  table {
    width: 100%;
    color: #272727;
    font-size: 14px;
    td {
      height: 30px;
    }
    .c_3fa396 {
      color: #3fa396;
    }
  }
}
.redInput {
  &::v-deep .el-input__inner {
    color: red;
    text-align: center;
    font-weight: bold;
  }
}
.greenInput {
  &::v-deep .el-input__inner {
    color: green;
    text-align: center;
    font-weight: bold;
  }
}
</style>
